<template>
  <!-- 用户档案 -->
  <div class="index-container">
    <div class="index-content">
      <div class="nav-box">
        首页 > 大健康人才培训 > 课程列表
        <span>> 用户档案</span>
      </div>
      <div class="profile-content">
        <div class="p-title">基本信息</div>
        <div class="info-box">
          <div class="info-list">
            <span><b style="color: red">*</b>姓名</span>
            <el-input
              v-model="info.username"
              placeholder="请输入姓名"
            ></el-input>
          </div>
          <div class="info-list">
            <span><b style="color: red">*</b>性别</span>
            <el-select v-model="info.sex" placeholder="请选择">
              <el-option
                v-for="item in genderList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="info-box">
          <!-- <div class="info-list">
            <span>出生日期</span>
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="info.birthday"
              type="date"
              placeholder="请选择日期"
            ></el-date-picker>
          </div> -->
          <div class="info-list">
            <span>民族</span>
            <el-select v-model="info.nation" placeholder="请选择">
              <el-option
                v-for="item in nationList"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="info-box">
          <div class="info-list">
            <span>籍贯</span>
            <el-cascader
              :props="props"
              @change="nativeChange"
              :options="nativeList"
              v-model="native_place"
              placeholder="请选择"
            ></el-cascader>
          </div>
          <div class="info-list">
            <span>政治面貌</span>
            <el-select v-model="info.political_outlook" placeholder="请选择">
              <el-option
                v-for="item in politicsList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="info-box">
          <div class="info-list">
            <span>毕业院校</span>
            <el-input v-model="info.school" placeholder="请填写校区"></el-input>
          </div>
          <div class="info-list">
            <span>学历</span>
            <el-select v-model="info.education" placeholder="请选择">
              <el-option
                v-for="item in educationList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="info-box">
          <div class="info-list">
            <span>专业</span>
            <el-input v-model="info.major" placeholder="请填写专业"></el-input>
          </div>
          <div class="info-list">
            <span><b style="color: red">*</b>证件类型</span>
            <el-select v-model="info.id_type" placeholder="请选择">
              <el-option
                v-for="item in codeTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="info-list single-list">
          <span><b style="color: red">*</b>证件号码</span>
          <el-input v-model="info.id_no"></el-input>
        </div>
        <div class="info-list single-list">
          <span><b style="color: red">*</b>手机号</span>
          <el-input v-model="info.mobile"></el-input>
        </div>
        <div class="info-list single-list">
          <span>邮箱</span>
          <el-input v-model="info.email"></el-input>
        </div>
        <div class="info-list single-list">
          <span>家庭住址</span>
          <el-input v-model="info.home_addr"></el-input>
        </div>
        <div class="info-list single-list">
          <span>现居住地</span>
          <el-input v-model="info.current_addr"></el-input>
        </div>
        <div class="info-box">
          <div class="info-list">
            <span>紧急联系人</span>
            <el-input v-model="info.emergency_contact"></el-input>
          </div>
          <div class="info-list">
            <span>紧急电话</span>
            <el-input v-model="info.emergency_phone"></el-input>
          </div>
        </div>
        <div class="info-list single-list">
          <span>爱好特长</span>
          <el-input v-model="info.specialty"></el-input>
        </div>
        <div class="info-list single-list">
          <span>健康状况</span>
          <el-select v-model="info.health_status" placeholder="请选择">
            <el-option
              v-for="item in healthList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="info-list single-list">
          <span>机构</span>
          <el-select v-model="info.schoole_uuid" placeholder="请选择">
            <el-option
              v-for="item in schoolList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="info-list single-list">
          <span>工作年限</span>
          <el-input min="0" v-model="info.work_year" type="number"></el-input>
        </div>
        <div class="p-title">工作经历</div>
        <div class="job-box">
          <el-radio
            v-for="(item, index) in jobList"
            :key="'job' + index"
            v-model="info.experience"
            :label="item"
            >{{ item }}</el-radio
          >
        </div>
        <div class="tip-text">
          填表人声明
          <span>（必选）</span>
        </div>
        <div class="rule-text">1.本人保证所填写资料属实。</div>
        <div class="rule-text">2.保证遵守学校各项规章制度。</div>
        <div class="agree-box">
          <el-radio
            v-for="(item, index) in agreeList"
            :key="'job' + index"
            v-model="agree"
            :label="item.value"
            @change="agreeChange"
            >{{ item.label }}</el-radio
          >
        </div>
        <div class="submit-button" @click="submit">提交表单</div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../api/api";
export default {
  name: "userProfiles",
  data() {
    return {
      info: {
        username: "",
        sex: "",
        birthday: "",
        nation: "",
        native_place: "",
        political_outlook: "",
        school: "",
        education: "",
        major: "",
        id_type: 1,
        id_no: "",
        mobile: "",
        email: "",
        home_addr: "",
        current_addr: "",
        emergency_contact: "",
        emergency_phone: "",
        specialty: "",
        health_status: "",
        schoole_uuid: "",
        experience: "",
        agree: "",
        work_year: 0,
        province: "",
        city: "",
      },
      native_place: [],
      agree: "",
      genderList: [
        {
          label: "男",
          value: 1,
        },
        {
          label: "女",
          value: 2,
        },
      ],
      nationList: [
        { id: 1, name: "汉族" },
        { id: 2, name: "蒙古族" },
        { id: 3, name: "回族" },
        { id: 4, name: "藏族" },
        { id: 5, name: "维吾尔族" },
        { id: 6, name: "苗族" },
        { id: 7, name: "彝族" },
        { id: 8, name: "壮族" },
        { id: 9, name: "布依族" },
        { id: 10, name: "朝鲜族" },
        { id: 11, name: "满族" },
        { id: 12, name: "侗族" },
        { id: 13, name: "瑶族" },
        { id: 14, name: "白族" },
        { id: 15, name: "土家族" },
        { id: 16, name: "哈尼族" },
        { id: 17, name: "哈萨克族" },
        { id: 18, name: "傣族" },
        { id: 19, name: "黎族" },
        { id: 20, name: "傈僳族" },
        { id: 21, name: "佤族" },
        { id: 22, name: "畲族" },
        { id: 23, name: "高山族" },
        { id: 24, name: "拉祜族" },
        { id: 25, name: "水族" },
        { id: 26, name: "东乡族" },
        { id: 27, name: "纳西族" },
        { id: 28, name: "景颇族" },
        { id: 29, name: "柯尔克孜族" },
        { id: 30, name: "土族" },
        { id: 31, name: "达翰尔族" },
        { id: 32, name: "么佬族" },
        { id: 33, name: "羌族" },
        { id: 34, name: "布朗族" },
        { id: 35, name: "撒拉族" },
        { id: 36, name: "毛南族" },
        { id: 37, name: "仡佬族" },
        { id: 38, name: "锡伯族" },
        { id: 39, name: "阿昌族" },
        { id: 40, name: "普米族" },
        { id: 41, name: "塔吉克族" },
        { id: 42, name: "怒族" },
        { id: 43, name: "乌孜别克族" },
        { id: 44, name: "俄罗斯族" },
        { id: 45, name: "鄂温克族" },
        { id: 46, name: "德昂族" },
        { id: 47, name: "保安族" },
        { id: 48, name: "裕固族" },
        { id: 49, name: "京族" },
        { id: 50, name: "塔塔尔族" },
        { id: 51, name: "独龙族" },
        { id: 52, name: "鄂伦春族" },
        { id: 53, name: "赫哲族" },
        { id: 54, name: "门巴族" },
        { id: 55, name: "珞巴族" },
        { id: 56, name: "基诺族" },
      ],
      nativeList: [],
      props: {
        value: "area_name",
        label: "area_name",
        children: "child",
      },
      politicsList: [
        {
          label: "群众",
          value: "群众",
        },
        {
          label: "党员",
          value: "党员",
        },
      ],
      educationList: [
        {
          label: "小学",
          value: "小学",
        },
        {
          label: "初中",
          value: "初中",
        },
        {
          label: "高中",
          value: "高中",
        },
        {
          label: "大专",
          value: "大专",
        },
        {
          label: "本科",
          value: "本科",
        },
        {
          label: "研究生",
          value: "研究生",
        },
        {
          label: "博士",
          value: "博士",
        },
      ],
      codeTypeList: [
        {
          label: "身份证",
          value: 1,
        },
        {
          label: "驾驶证",
          value: 2,
        },
      ],
      healthList: [
        {
          label: "健康",
          value: 1,
        },
        {
          label: "有遗传病史",
          value: 2,
        },
        {
          label: "有慢性病史",
          value: 3,
        },
      ],
      schoolList: [],
      jobList: ["育婴师", "护理员", "收纳师", "其他"],
      agreeList: [
        {
          label: "同意",
          value: 1,
        },
        {
          label: "不同意",
          value: 0,
        },
      ],
    };
  },
  mounted() {
    scrollTo(0, 0);
  },
  created() {
    this.getProvince();
    this.getDetail();
    this.getSchoolList();
  },
  methods: {
    // 获取学校列表
    async getSchoolList() {
      const res = await api.getSchoolList({ page_index: 1, page_size: 999 });
      if (!res.result) return;
      this.schoolList = res.result.data.map((v) => ({
        label: v.title,
        value: v.uuid,
      }));
    },

    //   获取详情
    getDetail() {
      api.getMyinfo().then((res) => {
        if (res.result) {
          this.info.username = res.result.real_name;
          this.info.mobile = res.result.phone;
        }
      });
    },
    // 获取省市区街道
    getProvince() {
      api.getProvince().then((res) => {
        this.nativeList = res.result;
      });
    },
    agreeChange(val) {
      this.info.agree = val;
    },
    nativeChange(val) {
      this.info.native_place = val[0] + val[1];
      this.info.province = val[0];
      this.info.city = val[1];
    },
    getBirthdayFromIdCard(idCard) {
      let birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 15) {
          birthday = "19" + idCard.substr(6, 6);
        } else if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
        }

        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      }

      return birthday;
    },
    // 提交表单
    submit() {
      // else if (!this.info.birthday) {
      //   this.$message.warning('请选择出生日期！');
      // }

      // else if (birth !== this.info.birthday) {
      //   this.$message.warning('出生日期和证件号码出生日期不一致！');
      // }
      const birth = this.getBirthdayFromIdCard(this.info.id_no);
      if (!this.info.username) {
        this.$message.warning("请输入姓名！");
      } else if (!this.info.sex) {
        this.$message.warning("请选择性别！");
      // } else if (!this.info.nation) {
      //   this.$message.warning("请选择民族！");
      // } else if (!this.info.native_place) {
      //   this.$message.warning("请选择籍贯！");
      // } else if (!this.info.political_outlook) {
      //   this.$message.warning("请选择政治面貌！");
      // } else if (!this.info.education) {
      //   this.$message.warning("请选择学历！");
      // } else if (!this.info.major) {
      //   this.$message.warning("请输入专业！");
      } else if (!this.info.id_type) {
        this.$message.warning("请选择证件类型！");
      } else if (!this.info.id_no) {
        this.$message.warning("请输入证件号码！");
      } else if (!this.info.mobile) {
        this.$message.warning("请输入手机号码！");
      // } else if (!this.info.home_addr) {
      //   this.$message.warning("请输入家庭住址！");
      // } else if (!this.info.current_addr) {
      //   this.$message.warning("请输入现居住地！");
      // } else if (!this.info.emergency_contact) {
      //   this.$message.warning("请输入紧急联系人姓名！");
      // } else if (!this.info.emergency_phone) {
      //   this.$message.warning("请输入紧急联系人电话！");
      // } else if (!this.info.health_status) {
      //   this.$message.warning("请选择健康状况！");
      // } else if (!this.info.schoole_uuid) {
      //   this.$message.warning("请选择机构！");
      // } else if (this.info.work_year === "") {
      //   this.$message.warning("请输入工作年限！");
      // } else if (!this.info.experience) {
      //   this.$message.warning("请选择工作经历！");
      } else if (this.agree !== 1) {
        this.$message.warning("请选择同意该声明！");
      } else {
        api.saveMyInformation(this.info).then((res) => {
          if (res && res.result) {
            this.$message.success("提交成功！");
            this.$router.back(-1);
          } else {
            this.$message.warning("提交失败！");
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122px;
  background-color: #f8f7f6;
}
.index-content {
  width: 72%;
  padding: 50px 0;
  margin: 0 auto;
}
.nav-box {
  padding-bottom: 46px;
  font-size: 16px;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.profile-content {
  padding: 22px 32px 66px;
  background-color: #ffffff;
  .p-title {
    margin-bottom: 34px;
    padding-bottom: 16px;
    font-size: 16px;
    color: #f1a475;
    border-bottom: 1px solid #e7e7e7;
  }
}
.info-box {
  display: flex;
  padding: 0 0 26px 0;
}
.info-list {
  display: flex;
  align-items: center;
  margin-right: 40px;
  span {
    width: 84px;
    padding-right: 14px;
    text-align: right;
  }
}

/deep/ {
  .el-input,
  .el-select {
    width: 218px !important;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #f1a475;
    background: #f1a475;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #f1a475;
  }
  .el-radio__inner:hover {
    border-color: #f1a475;
  }
}
.single-list {
  margin-bottom: 26px;
  /deep/ {
    .el-input,
    .el-select {
      width: 558px !important;
    }
  }
}
.job-box {
  padding-bottom: 54px;
}
.tip-text {
  padding-bottom: 26px;
  font-size: 16px;
  font-weight: bold;
  span {
    color: #f90000;
  }
}
.rule-text {
  padding-bottom: 6px;
}
.agree-box {
  padding: 32px 0 76px;
}
.submit-button {
  width: 342px;
  height: 64px;
  margin: 0 auto;
  font-size: 20px;
  color: #ffffff;
  line-height: 64px;
  text-align: center;
  background-color: #f1a373;
  border-radius: 45px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userProfiles.vue